import React from 'react';
import styled from 'styled-components';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import Bugsnag from '@bugsnag/js';
import { getPluginId } from '../helpers';
import { colors } from '../styles';
import Button from './Education/components/Button';

const ErrorContainer = styled.div`
  padding: 40px;
  text-align: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 600px;
  margin: 50px auto;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const ErrorTitle = styled.h1`
  color: ${colors.RC_RED};
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 600;
`;

const ErrorText = styled.p`
  color: ${colors.GREY};
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 1.5;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
`;

function ErrorFallback({ error, }) {
  return (
    <ErrorContainer>
      <ErrorTitle>Application Error</ErrorTitle>
      <ErrorText>
        Something went wrong with the application. Please try refreshing the page.
      </ErrorText>
      <ButtonContainer>
        <Button
          type="button"
          onClick={() => window?.location?.reload()}
          mainColor={'1E83D3'}
          padding="12px 24px"
          fontSize="16px"
          margin="0"
        >
          Try Again
        </Button>

      </ButtonContainer>
    </ErrorContainer>
  );
}

const ErrorBoundary = ({ children }) => (
  <ReactErrorBoundary
    FallbackComponent={ErrorFallback}
    onError={(error, errorInfo) => {
      Bugsnag.notify(new Error(`Error: ${error?.message} | Plugin ID: ${getPluginId()} | Error Info: ${JSON.stringify(errorInfo)}`));
    }}
  >
    {children}
  </ReactErrorBoundary>
);

export default ErrorBoundary;
export { ErrorFallback };
